import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Control, Controller } from 'react-hook-form';

import FieldError from '@/forms/FieldError';
import { DocumentField } from '@/types/generatedDocument';
import Checkbox from '@/ui/components/Form/Checkbox';
import Datepicker from '@/ui/components/Form/Datepicker';
import Label from '@/ui/components/Form/Label';
import RichTextEditor from '@/ui/components/Form/RichTextEditor';
import Tooltip from '@/ui/components/Tooltip';

export const renderField = (
  field: DocumentField,
  control: Control,
  errors: { [key: string]: string[] }
) => {
  const fieldErrors = errors[field.name];

  const label = (
    <span className="flex items-center">
      {field.label}
      {field.required ? '*' : ''}
      {field.tooltip?.staff_tooltip && (
        <Tooltip tooltipContent={field.tooltip.staff_tooltip}>
          <FontAwesomeIcon icon={faInfoCircle} className="ml-1 text-gray-500" />
        </Tooltip>
      )}
    </span>
  );

  switch (field.format) {
    case 'bool':
      return (
        <div key={field.name} className="mb-4">
          <Controller
            control={control}
            name={field.name}
            defaultValue={field.value}
            render={({ field: { onChange, value } }) => (
              <>
                <Checkbox
                  id={field.name}
                  label={label}
                  checked={!!value}
                  onChange={(e) => onChange(e.target.checked)}
                />
                {fieldErrors &&
                  fieldErrors.map((err, idx) => <FieldError key={idx} message={err} />)}
              </>
            )}
          />
        </div>
      );
    case 'date':
      return (
        <div key={field.name} className="mb-4">
          <Controller
            control={control}
            name={field.name}
            defaultValue={field.value}
            render={({ field: { onChange, value, onBlur } }) => (
              <>
                <Datepicker
                  label={label}
                  name={field.name}
                  value={typeof value === 'string' ? value : ''}
                  onChange={onChange}
                  onBlur={onBlur}
                />
                {fieldErrors &&
                  fieldErrors.map((err, idx) => <FieldError key={idx} message={err} />)}
              </>
            )}
          />
        </div>
      );
    case 'rich_text':
      return (
        <div key={field.name} className="mb-4">
          <Label htmlFor={field.name} text={label} />
          <Controller
            control={control}
            name={field.name}
            defaultValue={field.value}
            render={({ field: { onChange, value } }) => (
              <>
                <RichTextEditor
                  value={typeof value === 'string' ? value : ''}
                  onChange={onChange}
                />
                {fieldErrors &&
                  fieldErrors.map((err, idx) => <FieldError key={idx} message={err} />)}
              </>
            )}
          />
        </div>
      );
    default:
      return null;
  }
};
